export function getInitialState () {
    return {
        initialized: false,
        drawerOpen: false,
    };
}

const pendoCollaboration = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setInitialized (state, { initialized }) {
            state.initialized = initialized;
        },
        setDrawerOpen (state, { drawerOpen }) {
            state.drawerOpen = drawerOpen;
        },
    },
    actions: {
        init ({ commit }) {
            commit('setInitialized', { initialized: true });
        },
        toggleDrawer ({ commit, state }) {
            commit('setDrawerOpen', { drawerOpen: !state.drawerOpen });
        },
        teardown ({ state }) {
            Object.assign(state, getInitialState());
        },
    },
    getters: {
        hasPendoCollaboration: (_state, _getters, _rootState, rootGetters) => {
            return rootGetters['auth/hasSegmentFlag']('pendoCollaboration');
        },
        hasCollaborationAccess: (state) => {
            return state.initialized;
        },
    },
};

export default pendoCollaboration;
